import { render, staticRenderFns } from "./bzjd.vue?vue&type=template&id=65362a86&scoped=true&"
import script from "./bzjd.vue?vue&type=script&lang=js&"
export * from "./bzjd.vue?vue&type=script&lang=js&"
import style0 from "./bzjd.vue?vue&type=style&index=0&id=65362a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65362a86",
  null
  
)

export default component.exports